var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('page-section', {
    staticClass: "page-section--sm primary lighten-5",
    scopedSlots: _vm._u([{
      key: "tit",
      fn: function () {
        return [_c('h2', {
          staticClass: "tit tit--lg text-center"
        }, [_vm._v(" 더 나은 삶을 위한 유익하고 좋은 균, "), _c('br', {
          staticClass: "d-none d-lg-block"
        }), _vm._v(" 그 출발점은 바로 "), _c('span', {
          staticClass: "primary--text"
        }, [_vm._v("식물유래")]), _vm._v(" 입니다. ")])];
      },
      proxy: true
    }])
  }, [_c('v-row', [_vm._l(_vm.items, function (item, index) {
    return _c('v-col', {
      key: index,
      attrs: {
        "cols": "12",
        "md": "6",
        "xl": "4"
      }
    }, [_c('v-card', {
      staticClass: "item-card",
      attrs: {
        "tile": "",
        "flat": ""
      }
    }, [_c('v-img', {
      staticClass: "item-card__icon",
      attrs: {
        "src": item.icon,
        "alt": ""
      }
    }), _c('div', [_c('v-card-title', [_c('div', {
      staticClass: "tit tit--sm",
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    })]), _c('v-card-text', [_c('ul', _vm._l(item.children, function (child, index) {
      return _c('li', {
        key: index,
        staticClass: "txt txt--lg font-weight-medium line-height-15"
      }, [_c('v-row', {
        staticClass: "row--sm"
      }, [_c('v-col', {
        attrs: {
          "cols": "auto"
        }
      }, [_vm._v("·")]), _c('v-col', [_vm._v(_vm._s(child))])], 1)], 1);
    }), 0)])], 1)], 1)], 1);
  }), _c('v-col', {
    staticClass: "d-none d-md-block",
    attrs: {
      "cols": "12",
      "md": "6",
      "xl": "4"
    }
  }, [_c('v-card', {
    staticClass: "item-card",
    attrs: {
      "img": "/images/about/plant-logo.png",
      "tile": "",
      "flat": ""
    }
  })], 1)], 2)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }